import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { convertBoolValue, getImageUrlPath } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: Response) => {
  const responseData = data?.data?.responseObject ?? []
  const retData = responseData.map((item: any) => ({
    id: item?.product?.id,
    autoPayAllow: convertBoolValue(item?.standingInstruction?.autoPayAllow),
    categoryId: item?.category?.id,
    logoPath: getImageUrlPath(item?.product?.logoName ?? ''),
    name: item?.product?.name,
    shortName: item?.product?.displayName,
    type: item?.product?.type,
    isBbps: convertBoolValue(item?.product?.isBbps),
    maxAmount: item?.product?.maxAmount,
    minAmount: item?.product?.minAmount,
    searchTags: item?.product?.operatorSearchTag,
    partialPaymentAllow: convertBoolValue(item?.product?.partialPaymentAllow),
    partialPaymentType: item?.product?.partialPaymentType ?? '',
    billFetchAllow: convertBoolValue(item?.product?.billFetchAllow),
    isExistingBiller: false,
    fields: [],
    iDEBPP: item.billerIDEBPP ?? 0,
    circles: [],
    distributor: [],
    amountLov: item?.product?.amountLov ?? '',
    nickNameField: {
      id: 0,
      // nickNameSuggestions: [],
      // nickNameValidationPattern: '',
      // nickNameValidationMessage: null,
    },
  }))
  return retData
}

export const returnBillRequest = (billerCategoryMasterId: number | string) => {
  return {
    category: {
      id: billerCategoryMasterId,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

export const getOperatorList = (tokens, userAccessToken, billerCategoryMasterId: number) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getOperatorList,
    method: 'POST',
    config: config,
    body: returnBillRequest(billerCategoryMasterId),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.responseStatus?.code === '000') {
      return responseParser(data)
    } else {
      const errorMsg = {
        errorCode: data?.data?.error?.code,
        errorMessage: data?.data?.error?.message,
      }
      throw errorMsg
    }
  })
}
